import { api, catchErrorHandler } from "utils/api";

export const bshopList = async ({ page }) => {
  try {
    const { data } = await api.post(`/bshop/banners`, {
      criteria: {
        page: page,
        pageSize: 10,
      },
    });
    return data;
  } catch (error) {
    return catchErrorHandler(error, "bshopList", false);
  }
};
